import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { GenericDropDownV3, LL_H_C, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_ColorGroup } from './ModuleFE_ColorGroup.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const renderColorGroupOption = (item) => _jsxs(LL_H_C, { style: { width: '100%', gap: 12 }, children: [_jsx("span", { style: { flex: 1 }, children: item.label }), _jsx(LL_H_C, { style: { gap: 3, marginLeft: 'auto' }, children: (item.colors ?? []).map((color, idx) => _jsx("span", { style: {
                    width: 16,
                    height: 16,
                    borderRadius: 3,
                    backgroundColor: color,
                    border: '1px solid rgba(0, 0, 0, 0.15)',
                } }, idx)) })] });
const Props_DropDown = {
    module: ModuleFE_ColorGroup,
    modules: [ModuleFE_ColorGroup],
    mapper: item => [item.label],
    placeholder: 'Choose a color group',
    renderer: renderColorGroupOption
};
export const DropDown_ColorGroup = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_ColorGroup,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item.label] });
    },
    uiSelector: DropDown_ColorGroup.selectable,
});
export const MultiSelect_ColorGroup = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map